
export const RepositoryIntro = () => {
  return (
    <div className="max-w-3xl mx-auto text-center mb-16">
      <p className="text-lg text-muted-foreground">
        Vous entendez parler du RNCP, du ROME, du RIME, de Référens III, du REME et du RMFP. Mais à quoi servent tous ces répertoires ? Pas de panique, on vous explique tout, de façon claire et simple. Ces outils existent pour organiser les métiers, les compétences et les certifications professionnelles, mais leur complexité freine parfois leur utilisation. Grâce à Skillengers, tout devient interopérable et accessible.
      </p>
    </div>
  );
};
